import { notificationContextTypes } from "../../utils/typeDefs";
import { useState, createContext } from "react";

type notificationContextProps = {
  children?: JSX.Element;
};

const NotificationContext = createContext<notificationContextTypes | null>(
  null
);

const NotificationContextProvider = ({
  children,
}: notificationContextProps) => {
  const [success, setSuccess] = useState<boolean>(false);
  const [notificationShow, setNotificationShow] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const handleNotificationOpen = () => {
    setNotificationShow(true);
  };

  const handleNotificationClose = () => {
    setNotificationShow(false);
  };

  function triggerNotification(value: boolean, message: string) {
    setSuccess(value);
    setMessage(message);
    handleNotificationOpen();
    notificationTimer();
  }

  const notificationTimer = () => {
    setTimeout(() => {
      handleNotificationClose();
    }, 4000);
  };

  return (
    <NotificationContext.Provider
      value={{
        handleNotificationClose,
        notificationShow,
        triggerNotification,
        success,
        message,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export { NotificationContext, NotificationContextProvider };
